<template>
    <div>
        <b-card>
            <h2>My Groups</h2>
            <div class="d-flex">
                <router-link
                    :to="{ name: 'add_group' }"
                >
                    <font-awesome-icon
                        icon="plus-circle"
                        class="mr-1"
                    ></font-awesome-icon>
                    Add
                </router-link>
            </div>
        </b-card>
        <b-card-group class="mt-4" columns>
            <b-card
                v-for="(group, idx) in groups"
                :key="idx"
            >
                <h4>{{ group.group_name }} <b-badge v-if="!group.enabled">Disabled</b-badge></h4>
                <div class="mt-2">
                    <b-button
                        v-if="group.group_base_url"
                        variant="link"
                        @click="openGroup(group)"
                        :disabled="!group.enabled"
                    >
                        <font-awesome-icon icon="external-link-alt" class="mr-1" />
                        Group Site
                    </b-button>
                    <b-button
                        v-if="group.group_admin_base_url"
                        variant="link"
                        @click="switchGroup(group)"
                        :disabled="!group.enabled"
                    >
                        <font-awesome-icon icon="tachometer-alt" class="mr-1" />
                        Group Admin
                    </b-button>
                </div>
            </b-card>
        </b-card-group>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            groups: [],
            selected: null
        };
    },
    mounted() {
        this.listGroups();
    },
    methods: {
        listGroups() {
            this.$api.get(
                "/api/admin/groups/list"
            ).then(({ data: { records, selected_group_id } }) => {
                this.groups   = records;
                this.selected = selected_group_id;
            });
        },
        switchGroup({ group_admin_base_url }) {
            // this.$api.post(
            //     "/api/admin/groups/switch",
            //     { group_id }
            // ).then(({ data: { group, semester } }) => {
            //     this.$store.commit("setGroup",    group);
            //     this.$store.commit("setSemester", semester);
            //     console.log(group, semester);
            // });
            window.open(`${group_admin_base_url}?token=${localStorage.getItem('token')}`, "_blank");
        },
        openGroup({ group_base_url }) {
            window.open(`${group_base_url}?token=${localStorage.getItem('token')}`, "_blank");
        }
    },
    computed: mapState(["token"])
}
</script>